import type { FC } from 'react';
import { StyleSheet, View } from 'react-native';
import type ApiLoyaltyBenefits from 'src/core/models/api/ApiLoyaltyBenefits';
import Dimens from 'src/core/utils/Dimens';
import Translations from 'src/core/utils/Translations';
import { useLoyaltyStore } from 'src/domain/stores/useLoyaltyStore';
import SectionTitle from 'src/presentation/components/molecules/SectionTitle';
import BenefitGridCard from 'src/presentation/components/organisms/BenefitGridCard';

interface Props {
	benefits?: ApiLoyaltyBenefits | undefined;
}

const Benefits: FC<Props> = ({ benefits }) => {
	const { entranceKey } = useLoyaltyStore();

	const cards = benefits?.cards ?? [];

	return (
		<View style={styles.container}>
			<SectionTitle
				subtitle={Translations.loyaltyBenefitsSubtitle}
				title={Translations.loyaltyPersonalBenefitsWithCount(cards.length)}
			/>
			<View key={entranceKey} style={styles.grid}>
				{cards.map((card, index) => (
					<BenefitGridCard card={card} index={index} key={card.id} />
				))}
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	container: {
		paddingVertical: Dimens.padding24,
		paddingHorizontal: Dimens.padding18,
		gap: Dimens.gap24,
	},
	grid: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: Dimens.gap16,
	},
});

export default Benefits;
